export default __webpack_public_path__ + "static/media/linkedin-box-fill.46158aca.svg";